import React from "react";
import { useMediaQuery, Box, Text, Flex, Avatar } from "@chakra-ui/react";
import { colors } from "../../definitions/constants/GlobalStyles";
import { AuthorComments } from "../../definitions/interfaces/GlobalInterfaces";
import i18n from "../../i18n/i18n";

function PostAuthor({ comment }: AuthorComments) {
  const [isMobile] = useMediaQuery("(max-width: 992px)");

  return (
    <Box marginBottom={6} marginTop={2} paddingLeft={"15px"}>
      <Flex gap={2} p={isMobile ? "2" : "0"}>
        <Flex alignSelf="center">
          <Avatar
            boxSize="40px"
            borderRadius="100%"
            src={comment.image_url}
            name={comment.firstname + comment.lastname}
          />
        </Flex>
        <Flex direction="column" justifyContent="center">
          <Text
            fontSize="13px"
            fontWeight="600"
            lineHeight="18.51px"
            color={colors.figmaColors.black}
          >
            {comment.firstname}
            {comment.lastname}
          </Text>
          <Flex gap={2} alignItems="center">
            <Text
              fontSize="11px"
              fontWeight="400"
              lineHeight="18.51px"
              color={colors.figmaColors.grey3}
            >
              {(() => {
                if (!comment.created_at) return '';
                const createdAt = new Date(comment.created_at);
                const now = new Date();
                const diffMs = now.getTime() - createdAt.getTime();
                const diffSeconds = Math.floor(diffMs / 1000);
                const diffMinutes = Math.floor(diffSeconds / 60);
                const diffHours = Math.floor(diffMinutes / 60);
                const diffDays = Math.floor(diffHours / 24);

                if (diffMinutes < 60) {
                  return `${i18n.t("commented on")} ${diffMinutes} ${i18n.t("minutes")}`;
                } else if (diffHours < 48) {
                  return `${i18n.t("commented on")} ${diffHours} ${i18n.t("hours")}`;
                } else if (diffDays < 30) {
                  return `${i18n.t("commented on")} ${diffDays} ${i18n.t("days")}`;
                } else {
                  return `${i18n.t("commented on")} ${createdAt.toLocaleDateString()}`;
                }
              })()}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex justify="start" align="center" paddingLeft="48px">
        <Text
          fontSize="13px"
          fontWeight="400"
          lineHeight="18.51px"
          color={colors.figmaColors.grey3}
        >
          {comment.text}
        </Text>
      </Flex>
    </Box>
  );
}

export default PostAuthor;
